export const newsletterAnalyticsDe = {
  tab: 'Auswertungen',
  title: 'Datenschutzfreundliche Kampagnenauswertung',
  subtitle:
    'Technische Versandwerte werden aggregiert. Individuelle Öffnungen und Klicks bleiben ohne getrennte Freigabe ausgeblendet.',
  accuracy:
    'Öffnungs- und Klickwerte sind technisch ungenau. Datenschutz-Proxys und wahrscheinliche Scanner werden getrennt ausgewiesen beziehungsweise ausgeschlossen.',
  noData: 'Im gewählten Zeitraum liegen keine Werte vor.',
  campaigns: 'Kampagnenvergleich',
  timeline: 'Zeitverlauf',
  languages: 'Sprachen',
  segments: 'Segmente',
  date: 'Datum',
  name: 'Name',
  status: 'Status',
  locale: 'Sprache',
  segment: 'Segment',
  metrics: {
    planned: 'Geplant',
    sent: 'Versandversuche',
    providerAccepted: 'Vom Provider angenommen',
    providerReportedDelivered: 'Vom Provider als zugestellt gemeldet',
    temporarilyFailed: 'Temporär fehlgeschlagen',
    permanentlyFailed: 'Dauerhaft fehlgeschlagen',
    unsubscribed: 'Abmeldungen',
    complaints: 'Beschwerden',
    uniqueOpens: 'Eindeutige Öffnungen',
    uniqueClicks: 'Eindeutige Klicks',
    privacyProxyOpens: 'Datenschutz-Proxy-Öffnungen',
    automatedInteractionsExcluded: 'Ausgeschlossene Automatismen',
  },
  tracking: {
    title: 'Individuelles Tracking',
    enabled: 'Aktiviert',
    disabled: 'Deaktiviert (Standard)',
    operational: 'Fachliche Freigabe',
    dataProtection: 'Datenschutzfreigabe',
    approved: 'Freigegeben',
    missing: 'Fehlt',
    consentRequired: 'Separate Empfängereinwilligung verlangen',
    retentionDays: 'Aufbewahrung personenbezogener Messbezüge (Tage)',
    enable: 'Individuelles Tracking aktivieren',
    acknowledgement:
      'Ich bestätige, dass Konfiguration, Transparenz und Rechtsgrundlage extern geprüft werden müssen.',
    save: 'Tracking-Einstellungen speichern',
    approvalTitle: 'Unveränderliche Freigabe dokumentieren',
    kind: 'Freigabeart',
    action: 'Entscheidung',
    approve: 'Freigeben',
    withdraw: 'Widerrufen',
    reason: 'Begründung',
    evidence: 'Vollständige Nachweisbeschreibung',
    record: 'Entscheidung dokumentieren',
    history: 'Freigabeverlauf',
    saved: 'Tracking-Einstellungen wurden gespeichert.',
    recorded: 'Die unveränderliche Freigabeentscheidung wurde dokumentiert.',
    failed: 'Die Tracking-Konfiguration konnte nicht gespeichert werden.',
  },
} as const;

export const newsletterAnalyticsEn = {
  ...newsletterAnalyticsDe,
  tab: 'Analytics',
  title: 'Privacy-friendly campaign analytics',
  subtitle:
    'Technical delivery metrics are aggregated. Individual opens and clicks stay hidden without separate approval.',
  accuracy:
    'Open and click metrics are technically approximate. Privacy proxies and likely scanners are reported separately or excluded.',
  noData: 'No metrics are available for the selected period.',
  campaigns: 'Campaign comparison',
  timeline: 'Timeline',
  languages: 'Languages',
  segments: 'Segments',
  date: 'Date',
  name: 'Name',
  status: 'Status',
  locale: 'Language',
  segment: 'Segment',
  metrics: {
    planned: 'Planned',
    sent: 'Send attempts',
    providerAccepted: 'Provider accepted',
    providerReportedDelivered: 'Provider-reported delivered',
    temporarilyFailed: 'Temporarily failed',
    permanentlyFailed: 'Permanently failed',
    unsubscribed: 'Unsubscribes',
    complaints: 'Complaints',
    uniqueOpens: 'Unique opens',
    uniqueClicks: 'Unique clicks',
    privacyProxyOpens: 'Privacy-proxy opens',
    automatedInteractionsExcluded: 'Automated interactions excluded',
  },
  tracking: {
    ...newsletterAnalyticsDe.tracking,
    title: 'Individual tracking',
    enabled: 'Enabled',
    disabled: 'Disabled (default)',
    operational: 'Operational approval',
    dataProtection: 'Data-protection approval',
    approved: 'Approved',
    missing: 'Missing',
    consentRequired: 'Require separate recipient consent',
    retentionDays: 'Retention of personal measurement references (days)',
    enable: 'Enable individual tracking',
    acknowledgement:
      'I confirm that configuration, transparency and legal basis require external review.',
    save: 'Save tracking settings',
    approvalTitle: 'Document an immutable approval',
    kind: 'Approval type',
    action: 'Decision',
    approve: 'Approve',
    withdraw: 'Withdraw',
    reason: 'Reason',
    evidence: 'Complete evidence description',
    record: 'Record decision',
    history: 'Approval history',
    saved: 'Tracking settings were saved.',
    recorded: 'The immutable approval decision was recorded.',
    failed: 'The tracking configuration could not be saved.',
  },
} as const;

export const newsletterAnalyticsTr = {
  ...newsletterAnalyticsEn,
  tab: 'Analizler',
  title: 'Gizlilik dostu kampanya analizi',
  subtitle:
    'Teknik gönderim değerleri toplulaştırılır. Ayrı onay olmadan bireysel açılma ve tıklamalar gizli kalır.',
  accuracy:
    'Açılma ve tıklama değerleri teknik olarak yaklaşıktır. Gizlilik vekilleri ve olası tarayıcılar ayrı gösterilir veya hariç tutulur.',
  noData: 'Seçilen dönem için değer yok.',
  campaigns: 'Kampanya karşılaştırması',
  timeline: 'Zaman çizelgesi',
  languages: 'Diller',
  segments: 'Segmentler',
  date: 'Tarih',
  name: 'Ad',
  status: 'Durum',
  locale: 'Dil',
  segment: 'Segment',
  metrics: {
    planned: 'Planlanan',
    sent: 'Gönderim denemeleri',
    providerAccepted: 'Sağlayıcı kabul etti',
    providerReportedDelivered: 'Sağlayıcının teslim edildi bildirimi',
    temporarilyFailed: 'Geçici hata',
    permanentlyFailed: 'Kalıcı hata',
    unsubscribed: 'Abonelikten çıkışlar',
    complaints: 'Şikâyetler',
    uniqueOpens: 'Tekil açılmalar',
    uniqueClicks: 'Tekil tıklamalar',
    privacyProxyOpens: 'Gizlilik vekili açılmaları',
    automatedInteractionsExcluded: 'Hariç tutulan otomasyonlar',
  },
  tracking: {
    ...newsletterAnalyticsEn.tracking,
    title: 'Bireysel takip',
    enabled: 'Etkin',
    disabled: 'Devre dışı (varsayılan)',
    operational: 'Operasyonel onay',
    dataProtection: 'Veri koruma onayı',
    approved: 'Onaylı',
    missing: 'Eksik',
    consentRequired: 'Ayrı alıcı rızası iste',
    retentionDays: 'Kişisel ölçüm bağlarının saklama süresi (gün)',
    enable: 'Bireysel takibi etkinleştir',
    acknowledgement:
      'Yapılandırmanın, şeffaflığın ve hukuki dayanağın dışarıdan incelenmesi gerektiğini onaylıyorum.',
    save: 'Takip ayarlarını kaydet',
    approvalTitle: 'Değiştirilemez onayı belgele',
    kind: 'Onay türü',
    action: 'Karar',
    approve: 'Onayla',
    withdraw: 'Geri çek',
    reason: 'Gerekçe',
    evidence: 'Eksiksiz kanıt açıklaması',
    record: 'Kararı belgele',
    history: 'Onay geçmişi',
    saved: 'Takip ayarları kaydedildi.',
    recorded: 'Değiştirilemez onay kararı kaydedildi.',
    failed: 'Takip yapılandırması kaydedilemedi.',
  },
} as const;

export const newsletterAnalyticsFr = {
  ...newsletterAnalyticsEn,
  tab: 'Analyses',
  title: 'Analyse de campagne respectueuse de la vie privée',
  subtitle:
    'Les mesures techniques d’envoi sont agrégées. Les ouvertures et clics individuels restent masqués sans validation distincte.',
  accuracy:
    'Les mesures d’ouverture et de clic sont techniquement approximatives. Les proxys de confidentialité et scanners probables sont séparés ou exclus.',
  noData: 'Aucune mesure pour la période choisie.',
  campaigns: 'Comparaison des campagnes',
  timeline: 'Évolution',
  languages: 'Langues',
  segments: 'Segments',
  date: 'Date',
  name: 'Nom',
  status: 'Statut',
  locale: 'Langue',
  segment: 'Segment',
  metrics: {
    planned: 'Planifié',
    sent: 'Tentatives d’envoi',
    providerAccepted: 'Accepté par le fournisseur',
    providerReportedDelivered: 'Livré selon le fournisseur',
    temporarilyFailed: 'Échec temporaire',
    permanentlyFailed: 'Échec permanent',
    unsubscribed: 'Désinscriptions',
    complaints: 'Plaintes',
    uniqueOpens: 'Ouvertures uniques',
    uniqueClicks: 'Clics uniques',
    privacyProxyOpens: 'Ouvertures via proxy privé',
    automatedInteractionsExcluded: 'Automatismes exclus',
  },
  tracking: {
    ...newsletterAnalyticsEn.tracking,
    title: 'Suivi individuel',
    enabled: 'Activé',
    disabled: 'Désactivé (par défaut)',
    operational: 'Validation métier',
    dataProtection: 'Validation protection des données',
    approved: 'Validée',
    missing: 'Manquante',
    consentRequired: 'Exiger un consentement distinct du destinataire',
    retentionDays: 'Conservation des références personnelles de mesure (jours)',
    enable: 'Activer le suivi individuel',
    acknowledgement:
      'Je confirme que la configuration, la transparence et la base juridique doivent être examinées extérieurement.',
    save: 'Enregistrer les paramètres',
    approvalTitle: 'Documenter une validation immuable',
    kind: 'Type de validation',
    action: 'Décision',
    approve: 'Valider',
    withdraw: 'Retirer',
    reason: 'Motif',
    evidence: 'Description complète de la preuve',
    record: 'Documenter la décision',
    history: 'Historique des validations',
    saved: 'Paramètres de suivi enregistrés.',
    recorded: 'La décision immuable a été documentée.',
    failed: 'Impossible d’enregistrer la configuration.',
  },
} as const;

export const newsletterAnalyticsEs = {
  ...newsletterAnalyticsEn,
  tab: 'Analítica',
  title: 'Analítica de campañas respetuosa con la privacidad',
  subtitle:
    'Las métricas técnicas de envío se agregan. Las aperturas y clics individuales permanecen ocultos sin aprobación separada.',
  accuracy:
    'Las métricas de apertura y clic son técnicamente aproximadas. Los proxies de privacidad y posibles escáneres se separan o excluyen.',
  noData: 'No hay métricas para el período seleccionado.',
  campaigns: 'Comparación de campañas',
  timeline: 'Evolución',
  languages: 'Idiomas',
  segments: 'Segmentos',
  date: 'Fecha',
  name: 'Nombre',
  status: 'Estado',
  locale: 'Idioma',
  segment: 'Segmento',
  metrics: {
    planned: 'Planificado',
    sent: 'Intentos de envío',
    providerAccepted: 'Aceptado por el proveedor',
    providerReportedDelivered: 'Entregado según el proveedor',
    temporarilyFailed: 'Fallo temporal',
    permanentlyFailed: 'Fallo permanente',
    unsubscribed: 'Bajas',
    complaints: 'Quejas',
    uniqueOpens: 'Aperturas únicas',
    uniqueClicks: 'Clics únicos',
    privacyProxyOpens: 'Aperturas por proxy privado',
    automatedInteractionsExcluded: 'Automatismos excluidos',
  },
  tracking: {
    ...newsletterAnalyticsEn.tracking,
    title: 'Seguimiento individual',
    enabled: 'Activado',
    disabled: 'Desactivado (predeterminado)',
    operational: 'Aprobación operativa',
    dataProtection: 'Aprobación de protección de datos',
    approved: 'Aprobada',
    missing: 'Falta',
    consentRequired: 'Exigir consentimiento separado del destinatario',
    retentionDays: 'Retención de referencias personales de medición (días)',
    enable: 'Activar seguimiento individual',
    acknowledgement:
      'Confirmo que la configuración, transparencia y base jurídica requieren revisión externa.',
    save: 'Guardar ajustes',
    approvalTitle: 'Documentar una aprobación inmutable',
    kind: 'Tipo de aprobación',
    action: 'Decisión',
    approve: 'Aprobar',
    withdraw: 'Retirar',
    reason: 'Motivo',
    evidence: 'Descripción completa de la prueba',
    record: 'Registrar decisión',
    history: 'Historial de aprobaciones',
    saved: 'Ajustes guardados.',
    recorded: 'La decisión inmutable quedó registrada.',
    failed: 'No se pudo guardar la configuración.',
  },
} as const;

export const newsletterAnalyticsRu = {
  ...newsletterAnalyticsEn,
  tab: 'Аналитика',
  title: 'Аналитика кампаний с учётом конфиденциальности',
  subtitle:
    'Технические показатели отправки агрегируются. Индивидуальные открытия и переходы скрыты без отдельных разрешений.',
  accuracy:
    'Показатели открытий и переходов технически приблизительны. Прокси конфиденциальности и вероятные сканеры учитываются отдельно или исключаются.',
  noData: 'За выбранный период данных нет.',
  campaigns: 'Сравнение кампаний',
  timeline: 'Динамика',
  languages: 'Языки',
  segments: 'Сегменты',
  date: 'Дата',
  name: 'Название',
  status: 'Статус',
  locale: 'Язык',
  segment: 'Сегмент',
  metrics: {
    planned: 'Запланировано',
    sent: 'Попытки отправки',
    providerAccepted: 'Принято провайдером',
    providerReportedDelivered: 'Доставлено по данным провайдера',
    temporarilyFailed: 'Временная ошибка',
    permanentlyFailed: 'Постоянная ошибка',
    unsubscribed: 'Отписки',
    complaints: 'Жалобы',
    uniqueOpens: 'Уникальные открытия',
    uniqueClicks: 'Уникальные переходы',
    privacyProxyOpens: 'Открытия через приватный прокси',
    automatedInteractionsExcluded: 'Исключённая автоматика',
  },
  tracking: {
    ...newsletterAnalyticsEn.tracking,
    title: 'Индивидуальное отслеживание',
    enabled: 'Включено',
    disabled: 'Выключено (по умолчанию)',
    operational: 'Рабочее согласование',
    dataProtection: 'Согласование защиты данных',
    approved: 'Согласовано',
    missing: 'Отсутствует',
    consentRequired: 'Требовать отдельное согласие получателя',
    retentionDays: 'Хранение персональных связей измерений (дни)',
    enable: 'Включить индивидуальное отслеживание',
    acknowledgement:
      'Подтверждаю необходимость внешней проверки конфигурации, прозрачности и правового основания.',
    save: 'Сохранить настройки',
    approvalTitle: 'Документировать неизменяемое согласование',
    kind: 'Вид согласования',
    action: 'Решение',
    approve: 'Согласовать',
    withdraw: 'Отозвать',
    reason: 'Обоснование',
    evidence: 'Полное описание доказательства',
    record: 'Записать решение',
    history: 'История согласований',
    saved: 'Настройки сохранены.',
    recorded: 'Неизменяемое решение записано.',
    failed: 'Не удалось сохранить конфигурацию.',
  },
} as const;
